import React from "react";
import {TableBody, TableCell} from "@mui/material";
import TableRow from "@mui/material/TableRow";
import { Skeleton } from '@mui/material';


export const LoadingBody = ({rowsPerPage, columCounter}) => {
    return (
        <TableBody>
            {
                renderRows(rowsPerPage, renderCells(columCounter))
            }
        </TableBody>
    );
}

function renderCells(numOfCells) {
    let cells = [];
    for (let i = 0; i < numOfCells; i++) {
        cells.push(
            <TableCell key={i}>
                <Skeleton animation={i % 2 === 0 ? "wave" : "pulse"}/>
            </TableCell>
        )
    }
    return cells
}

function renderRows(numOfRows, cells) {
    let rows = []
    for (let i = 0; i < numOfRows; i++) {
        rows.push(
            <TableRow key={i}>
                {cells}
            </TableRow>
        )
    }
    return rows;
}
